import { IonHeader, IonTitle, IonToolbar } from "@ionic/react";
import { Loader } from "components";

import { FilterBar } from "~components/Organisms/IndexFilters";
import { initialLocalStorageFilterValues } from "~components/Organisms/IndexFilters/types";
import { translate, useLocalStorage } from "~utils";

import { useRequestIndexFilters, useRequests } from "./hooks";
import { RequestCount } from "./RequestCount";
import { RequestIndex } from "./RequestIndex";

export function ActiveRequestsPage() {
  const [ls, setLs] = useLocalStorage(
    "swing-schools:filters:active",
    initialLocalStorageFilterValues,
  );

  const queryResult = useRequests({
    showHistory: false,
    filters: ls,
  });

  const filteredRequests = useRequestIndexFilters(queryResult.data?.requests);

  if (queryResult.isLoading) return <Loader />;

  if (queryResult.isError) {
    return <div>Error loading requests</div>;
  }

  if (!queryResult.data) {
    return <Loader />;
  }

  return (
    <>
      <IonHeader collapse="condense">
        <IonToolbar>
          <IonTitle size="large">{translate("ROUTE_TABLE_ACTIVE_REQUESTS")}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <FilterBar page="active" ls={ls} setLs={setLs}></FilterBar>
      <RequestCount page="active" count={queryResult.data.total} />
      <RequestIndex
        requestType="active-requests"
        requests={filteredRequests}
        isError={queryResult.isError}
        hasNextPage={queryResult.data.hasNextPage}
        fetchNextPage={queryResult.data.fetchNextPage}
        isFetchingNextPage={queryResult.data.isFetchingNextPage}
      />
    </>
  );
}
